<template>
    <div class="shipping_conf">
        <h3 class="text-center">{{ $t('page.mapping.overview') }}</h3>
        <div class="form-group row">
            <label class="col-md-4 control-label">{{ $t('page.mapping.name_ext') }}</label>
            <div class="col-md-7 inputGroupContainer">
                <div class="input-group">
                    <span class="input-group-addon"></span>
                    <input type="text" class="form-control" v-model="shippingMappings.name">
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-md-4 control-label">{{ $t('page.shipping.VersandMethode') }}</label>
            <div class="col-md-7 inputGroupContainer">
                <div class="input-group">
                    <span class="input-group-addon"></span>
                    <select class="form-control" v-model="shippingMappings.shipping_method_id">
                        <option v-for="(shippingmethod, index) in ShippingMethods" :value="shippingmethod.id">{{shippingmethod.name}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-md-4 control-label">{{ $t('page.shipping.shop') }}</label>
            <div class="col-md-7 inputGroupContainer">
                <div class="input-group">
                    <span class="input-group-addon"></span>
                    <select class="form-control" v-model="shippingMappings.shop_id">
                        <option v-for="(shop, index) in shops" :value="shop.id">{{shop.name}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="form-group row btn-to-right">
            <button class="btn btn-primary" @click="submit()">{{ $t('page.shipping.ShippingMethodMapping') }}</button>
        </div>
    </div>
</template>

<script>
    import shippingMethodMappingService from "../../services/shippingMethodMappingService";
    import shopService from "../../services/shopService";
    import shipperService from "../../services/shipperService";
    import shippingMethodService from "../../services/shippingMethodService";

    export default {
        name: "ShippingMethodMappingEdit",
        props: [
            'shippingMethodID',
            'shopID'
        ],
        data() {
            return {
                shippingMappings: {},
                shops: null,
                shippers: null,
                ShippingMethods: null
            }
        },
        methods: {
            getShippingMethod() {
                shippingMethodMappingService.getByShopIDShippingMethodID(this.shopID, this.shippingMethodID).then(
                    (response) => {
                        this.shippingMappings = response;

                    });
            },
            getShops() {
                shopService.getAll().then(
                    (response) => {
                        this.shops = response;
                    });
            },
            getShippers() {
                shipperService.getAll().then(
                    (response) => {
                        this.shippers = response;
                    });
            },
            getShippingMethods() {
                shippingMethodService.getAll().then(
                    (response) => {
                        this.ShippingMethods = response;
                    });
            },
            isCreated(shippingMappings) {
                console.log(this.shopID, this.shippingMethodID, shippingMappings);
                if (this.shippingMethodID == null) {
                    shippingMethodMappingService.create(shippingMappings);
                } else {
                    shippingMethodMappingService.update(this.shopID, this.shippingMethodID, shippingMappings);
                }
            },
            submit(event) {
                this.isCreated(this.shippingMappings);
                this.$eventBus.$emit('shipping-method-mapping-create-edit');

            },
        },
        mounted() {
            this.getShippingMethod();
            this.getShops();
            this.getShippers();
            this.getShippingMethods();
        }
    }

</script>

<style scoped>

</style>